/**
 * Login Controller
 */
(function() {
	angular.module('app.login').controller('LoginController', LoginController);

	LoginController.$inject = [
		'authentication',
        'authenticationSettings',
        'azureSettings',
        '$rootScope',
		'$cookies',
		'$location',
		'$window'
	];
    function LoginController(authentication, authenticationSettings, azureSettings, $rootScope, $cookies, $location, $window) {
		var vm = this;
		vm.isLoginVisible = false;       
		// get params
		vm.isDefaultProvider = true;
		var defaultParam = $location.search().isDefaultProvider;
		if (notNullOrUndefined(defaultParam)) {
			vm.isDefaultProvider = defaultParam;
		}

		vm.isThirdParty = false;
		vm.orgCacheKey;

		var applicationCacheKey = $location.search().clientId;
		if (!applicationCacheKey) {
			// use MultiPointII by default
			applicationCacheKey = authenticationSettings.defaultApplicationCacheKey;
		}

		if ($location.search().timeout) {
			vm.errorMessage = 'You were logged out due to inactivity. Please log back in to continue.';
        }
        if (notNullOrUndefined($rootScope.errorMessage)) {
            vm.errorMessage = $rootScope.errorMessage;
        }
		if (
			notNullOrUndefined($location.search().thirdparty) &&
			$location.search().thirdparty.toLowerCase() === 'redcap'
		) {
			var userKey = $location.search().userkey;

			if (notNullOrUndefined(userKey)) {
				vm.orgCacheKey = $location.search().orgcachekey;
				vm.isThirdParty = true;
				var fingerprint = $location.search().hash || '';
				var isLocal = $location.search().local ? $location.search().local : 0;
				var version = $location.search().version ? $location.search().version : 1; //If no version, set version = 1 for default

				redCapLogin(userKey, vm.orgCacheKey, fingerprint, isLocal, version);
			}
		}

		if (!vm.isThirdParty) {
			init();
		}

		// Init function, ** does not fire on RedCap load **
		function init() {
			// setup model data
			vm.emailAddress = '';
			vm.password = '';
			vm.loggingIn = false;
			vm.authentication = authentication.authentication;
			vm.isLoginVisible = !vm.authentication.isAuth;

			if (vm.authentication.isAuth && $rootScope.redirectURL.length > 0 && !vm.isThirdParty) {
				$window.location.href = $rootScope.redirectURL;
			}

			vm.logoUrl = authenticationSettings.dynamicContentUrl + '/1234/x/images/solera-autopoint_logo2019.svg';

			// setup model functions
			vm.login = login;

			setLoginBackgroundImage();
			resetCookies();
		}

		function isTrue(value) {
			return value === true || value === 'true';
		}

		function notNullOrUndefined(value) {
			return value !== undefined && value !== 'undefined' && value !== null;
		}

		function resetCookies() {
			// RSC-1609 - clear cookies for switching environments
			var apCookieKeys = ['authorizationData', 'AutoPointApplicationCookie'],
				apDomains = ['local', 'qa', 'st'];

			angular.forEach(apCookieKeys, function(key) {
				//sub-environments
				angular.forEach(apDomains, function(subDomain) {
					$cookies.remove(key, { domain: '.' + subDomain + '.autopoint.com' });
				});

				//prod
				$cookies.remove(key, { domain: '.autopoint.com' });
			});
        }

        vm.RedirectLogin = function () {
            RedirectMFALogin();
        }  

        function RedirectMFALogin() {
            authentication.isUserExistInAzure(vm.emailAddress).then(function (data) {
                if (data != null & data != undefined & data != "") {
                     authentication.getNonce(vm.emailAddress).then(function (nonceResponse) {
                        var tenantName = azureSettings.tenantName;
                        var policyName = azureSettings.passwordlessPolicy;
                        var clientId = azureSettings.clientId;
                        var redirectUri = azureSettings.redirectUri;
                        var nonceData = nonceResponse.data
                        var redirect = $location.search().redirect || $rootScope.redirectURL;
                        redirect = redirect ? redirect.split('#')[0] : "";
                        var applicationClientId = '';
                        applicationCacheKey = $location.search().clientId ? $location.search().clientId.toUpperCase() : authenticationSettings.avenueCacheKey;
                        switch (redirect.toLowerCase()) {
                            case authenticationSettings.cpoUrl.toLowerCase() + '/#/':
                            case authenticationSettings.cpoUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.cpoCacheKey;
                                break;
                            case authenticationSettings.reportingUrl.toLowerCase() + '/#/reports/':
                            case authenticationSettings.reportingUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.reportingCacheKey;
                                break;
                        }
                        if (applicationClientId != '') {
                            applicationCacheKey = applicationClientId;
                        }
                        var url = "https://" + tenantName + ".b2clogin.com/" + tenantName + ".onmicrosoft.com/" + policyName + "/oauth2/v2.0/authorize?response_type=code&client_id=" + clientId + "&redirect_uri=" + redirectUri + "&scope=openid&code_challenge=" + nonceData.codeChallenge + "&code_challenge_method=S256&login_hint=" + vm.emailAddress + "&nonce=" + nonceData.userNonce + "&state=" + applicationCacheKey + ";" + vm.emailAddress + ";" + nonceData.userNonce + ";" + nonceData.codeVerifier;
                        $window.location.href = url;
                    },
                        function (err) {
                            $rootScope.value = err;
                            vm.errorMessage = "MFA Validation Cancelled. Please try again.";
                        });
                }
            },
                function (err) {
                    $rootScope.value = err;
                    vm.errorMessage = "MFA Validation Cancelled. Please try again.";
                });
        }

        vm.RedirectMfa = function () {
            window.open(authenticationSettings.helpdeskUrl);
        }
		function login() {
			vm.errorMessage = null;
			var request = {
				username: vm.emailAddress,
				password: vm.password,
				applicationCacheKey: applicationCacheKey,
				isDefaultProvider: vm.isDefaultProvider
            };         

			vm.loggingIn = true;
			authentication.login(request).then(
				function(response) {
                    var response = response.data;
                    vm.errorMessage = null;                    
                        //We need third party redirects handled slightly differently
                    if (vm.isThirdParty) {
                        var clientId = $location.search().clientId.toUpperCase()
                        var reportId= $location.search().reportId,
                        redirectUrl = $location.search().redirect
                        
                        search = '';

                        var authData = JSON.parse(localStorage.getItem('cookiedata'));
                        authentication.setAuthDataCookie(authData, true);
                        if (notNullOrUndefined(clientId) && !notNullOrUndefined(redirectUrl) && notNullOrUndefined(reportId)) {
                            var orgKey = $location.search().orgcachekey.toUpperCase();
                            
                            // build search string
                            angular.forEach($location.search(), function (value, key) {
                                search += key + '=' + value + '&';
                            });
                            //remove last ?
                            search = search.substring(0, search.length - 1);

                            if (clientId===authenticationSettings.reportingCacheKey && notNullOrUndefined(reportId))
                            {
                                $rootScope.redirectURL =
                                                 authenticationSettings.reportingUrl + '/#/reports/' + orgKey + '?' + search;
                            }
                            else{
                                $rootScope.redirectURL =
                                        authenticationSettings.ssoUrl +'/#/failed-login';
                            }
                        } else if (notNullOrUndefined(redirectUrl)) {
                            $rootScope.redirectUrl = redirectUrl;
                        }
                        $window.location.href = $rootScope.redirectURL;
                    }
                    else if (notNullOrUndefined(response.password_reset_required) &&
                        isTrue(response.password_reset_required)
                    ) {
                        $location.search().passReset = 1;
                        $location.path('/register');
                        return;
                    }
                    else { 
                        authentication.isUserRegisteredForMFA(vm.emailAddress).then(function (mfadata) {                             
                            if (!mfadata) {
                                $('#mfaModal').modal('show');
                            }
                            else {
                                RedirectMFALogin();
                            }
                        });
                    }
				},
                function (err) {
                  
                    $rootScope.value = err;                   
                    console.error('login error:', angular.copy(err));
					if (vm.isThirdParty) {
						$location.path('/failed-login');
                    }
                    if ($rootScope.value[0].statusText.includes("Invalid credentials")) {
                            vm.password = null;
                            vm.errorMessage = 'The supplied credentials do not match our records.';
                            vm.loggingIn = false;
                    }
                    else if ($rootScope.value[0].statusText.includes("Account is locked")) {
                            vm.password = null;
                        vm.errorMessage = 'Too many invalid login attempts.' + '\n' + 'Your account is currently locked.' + '\n' + 'For immediate assistance, contact your account Admin or Manager.';
                            vm.loggingIn = false;
                    }
                    else if ($rootScope.value[0].statusText.includes("Warning before locking")) {
                        vm.password = null;
                        vm.errorMessage = 'The supplied credentials do no match our records.' + '\n' + 'One more attempt left before account is locked.'
                        vm.loggingIn = false;
                    }
                    else if ($rootScope.value[0].statusText.includes("Account is expired")) {
                        $location.search().passReset = 1;
                        $location.path('/register');
                    }
                    else {
                        vm.password = null;
                        vm.errorMessage = 'Invalid username or password. Please try again.';
                        vm.loggingIn = false;
                    }
				}
			);
		}

		/**
		 * redCapLogin - Allows Red Cap to log users in using their credentials
		 * @param {*} userKey - User login ID
		 * @param {*} orgCacheKey (Optional) - Not used currently but will be used to specify a specific org in the future
		 * @param {*} fingerprint - A hash signature representing the request came from a trusted source
		 * @param {*} isLocal - DEV ONLY flag for testing with local ip address
		 * @param {*} version - To detemine what format of fingerprint to be verified
		 */
		function redCapLogin(userKey, orgCacheKey, fingerprint, isLocal, version) {
            vm.emailAddress = userKey;
			vm.password = "redcap"+fingerprint;

            login();
		}

		function setLoginBackgroundImage() {
			var host = $location.$$host;
			if (host.indexOf('mercedes') > -1) {
				$('.login-page').addClass('dsd-background');
			} else {
				var imgAr = [
					'/1234/x/images/sso-backgrounds/sso-back1.jpg',
					'/1234/x/images/sso-backgrounds/sso-back2.jpg',
					'/1234/x/images/sso-backgrounds/sso-back3.jpg',
					'/1234/x/images/sso-backgrounds/sso-back4.jpg',
					'/1234/x/images/sso-backgrounds/sso-back5.jpg',
					'/1234/x/images/sso-backgrounds/sso-back6.jpg',
					'/1234/x/images/sso-backgrounds/sso-back7.jpg',
					'/1234/x/images/sso-backgrounds/sso-back8.jpg',
					'/1234/x/images/sso-backgrounds/sso-back9.jpg',
					'/1234/x/images/sso-backgrounds/sso-back10.jpg',
					'/1234/x/images/sso-backgrounds/sso-back11.jpg',
					'/1234/x/images/sso-backgrounds/sso-back12.jpg'
				];

				var num = Math.floor(Math.random() * imgAr.length);
				var img = imgAr[num];
				$('.login-page').css('background-image', 'url(' + authenticationSettings.dynamicContentUrl + img + ')');
			}
		}
	}
})();
